import { Injectable } from '@angular/core';
import {Resolve, RouterStateSnapshot, ActivatedRouteSnapshot, Router} from '@angular/router';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import {StylesService} from '../services/styles.service';
import {GlobalConstantsService, onlyKitLevelFields} from '../services/global-constants.service';
import {KitService} from '../services/kit.service';


@Injectable()
export class KitUpdateResolver implements Resolve<any> {

  constructor(
    private stylesService: StylesService,
    private globalConstantsService: GlobalConstantsService,
    private kitService: KitService
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {

    return Observable.of(this.kitService.find(+route.params['id'])).flatMap(
          (kit) => {
            return this.stylesService.fetchAll$().flatMap(
              (styles) => {
                return this.globalConstantsService.getAll().flatMap(
                  (globalFields) => {
                    return Observable.of({
                      kit: kit,
                      styles: styles,
                      metaDataFields: onlyKitLevelFields(globalFields)
                    });
                  }
                );
              }
            );
          }
        );
  }
}





// WEBPACK FOOTER //
// ./src/app/resolvers/kit-update.resolver.ts